
    import Vue from 'vue';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import ivaConditionService from '@/apps/shared/services/ivaConditions-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import phoneValidateService from '@/apps/shared/services/phone-service';
    import localityService from '@/apps/shared/services/locality-service';
    import getSelectedProducerService from '@/apps/shared/services/selectedProducer-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import AgeService from '@/apps/shared/utils/CheckAges';

    const GROUP_LABELS = {
        under21: 'Menores a 21 años',
        between21And75: 'Entre 21 y 75 años',
        over75: 'Entre 75 y 84 años',
    };

    const MIN_OWNER_AGE = 18;
    const MIN_OWNER_AGE_MESSAGE = 'La persona que contrata debe ser mayor a 18 años';

    const MAX_PASSENGER_AGE = 84;

    export default Vue.extend({
        components: { WhatsApp, XBreadcrumb },
        name: 'TravelAssistancePolicyOwner',
        data() {
            return {
                planDescription: '',
                planPrice: '',
                planPriceArs: '',
                covers: [],
                departureDateFormatted: '',
                returnDateFormatted: '',
                breadcrumbItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Datos del Contratante', path: '/asistencia-viajero/contratante' },
                ],
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                documentTypeList: [{ id: "", text: "" }],
                ivaConditionList: [{ id: "", text: "" }],
                maxSelections: 2,
                docTypeSelected: null,
                ownerDocType: null,
                numDoc: null,
                firstName: "",
                lastName: "",
                nacimiento: null,
                stringDate: "",
                areaCode: null,
                telephone: null,
                email: null,
                selectedIvaCondition: null,
                isPersonExist: false,
                activeForm: false,
                activeFormPersonNoExist: false,
                searchButtonDisable: true,
                nextButtonDisable: true,
                messageErrorAge: null,
                messageErrorDigits: null,
                messageErrorAgeRange: null,
                tripEndDate: null,
                cuposDeclarados: { under21: 0, between21And75: 0, over75: 0 },
                accept: true,
                smallSize: "small",
                isContractorTraveling: true,
                contractorBeneficiaries: 'legalHeirs',
                policyOwner: null,
                // Dirección del contratante cuando la persona de BUP no tiene localidad (igual que AP)
                hasLocality: null,
                selectedLocality: null,
                streetName: null,
                numDom: null,
                piso: null,
                numDept: null,
                localityList: function (params) {
                    return localityService.getLocalityList(params)
                },
                referente: null,
                multiplePeopleWithSameIdentifier: [],
                personWithSameIdentifierSelected: null,
                isPeopleWithSameIdentifierModalOpen: false,
                multiplePeopleError: "",
            }
        },
        created() {
            window.globalThis.validateNumDoc = (val) => {
                let valid = true;
                let message = "";
                if (!this.docTypeSelected) {
                    return { valid: false, message: "Debe seleccionar un tipo de documento." };
                }
                val = String(val || "").trim();
                let numericVal = val.replace(/\D/g, "");
                if (this.docTypeSelected.id === 'D') {
                    if (numericVal.length !== 7 && numericVal.length !== 8) {
                        this.searchButtonDisable = true;
                        message = numericVal.length > 0 ? "La cantidad de dígitos es incorrecta." : "Este campo es obligatorio.";
                        valid = false;
                    } else {
                        this.searchButtonDisable = false;
                        valid = true;
                    }
                } else {
                    this.searchButtonDisable = false;
                }
                if (!val) { this.searchButtonDisable = true; }
                return { valid, message };
            };
            // Callback del autocomplete de Localidad (solo aplica cuando se pide la dirección)
            window.globalThis.validateLocality = function () {
                return this.hasLocality || Boolean(this.selectedLocality);
            }.bind(this);
        },
        methods: {
            setupAddressValidation(required: boolean) {
                const form = "#formData1";

                // Localidad
                NF.Validation.Field.removeField(form, "selectedLocality");
                if (required) {
                    NF.Validation.Field.addField(form, "selectedLocality", {
                        validators: {
                            notEmpty: {
                                message: "El campo Localidad es obligatorio."
                            }
                        }
                    });
                }

                // Calle
                NF.Validation.Field.removeField(form, "streetName");
                if (required) {
                    NF.Validation.Field.addField(form, "streetName", {
                        validators: {
                            notEmpty: {
                                message: "El campo Domicilio es obligatorio."
                            },
                            stringLength: {
                                max: 100,
                                message: "Máximo 100 caracteres."
                            }
                        }
                    });
                }

                // Número
                NF.Validation.Field.removeField(form, "numDom");
                if (required) {
                    NF.Validation.Field.addField(form, "numDom", {
                        validators: {
                            notEmpty: {
                                message: "El campo Número es obligatorio."
                            },
                            regexp: {
                                regexp: /^[0-9]{1,6}$/,
                                message: "Sólo números (1 a 6 dígitos)."
                            }
                        }
                    });
                }
            },

            forceValidateAddressIfNeeded() {
                if (!this.hasLocality) {
                    NF.Validation.Field.validate("#formData1", "selectedLocality");
                    NF.Validation.Field.validate("#formData1", "streetName");
                    NF.Validation.Field.validate("#formData1", "numDom");
                }
            },

            formatDate(date) {
                if (!date) return '';
                var d = new Date(date);
                return d.getDate().toString().padStart(2, '0') + '/' + (d.getMonth() + 1).toString().padStart(2, '0') + '/' + d.getFullYear();
            },

            // Calcula el grupo etario a la fecha de FIN del viaje (returnDate); si no está disponible, a hoy.
            // Debe mantenerse alineado con getAgeGroup de passengers.vue.
            getAgeGroup(birthday) {
                const age = this.getAgeAtTripEnd(birthday);
                if (age === null) return null;
                if (age < 21) return 'under21';
                if (age <= 75) return 'between21And75';
                return 'over75';
            },

            getAgeAtTripEnd(birthday) {
                if (!birthday) return null;
                let referenceDate = new Date();
                if (this.tripEndDate) {
                    const tripEnd = new Date(this.tripEndDate);
                    if (!isNaN(tripEnd.getTime())) referenceDate = tripEnd;
                }
                let bd;
                if (typeof birthday === 'string') {
                    const cleaned = birthday.replace(/^"|"$/g, '');
                    if (cleaned.includes('T') || cleaned.includes('-')) {
                        bd = new Date(cleaned);
                    } else if (cleaned.includes('/')) {
                        bd = new Date(cleaned.split('/').reverse().join('/'));
                    } else {
                        bd = new Date(cleaned);
                    }
                } else {
                    bd = new Date(birthday);
                }
                if (isNaN(bd.getTime())) return null;
                let age = referenceDate.getFullYear() - bd.getFullYear();
                const m = referenceDate.getMonth() - bd.getMonth();
                if (m < 0 || (m === 0 && referenceDate.getDate() < bd.getDate())) age--;
                return age;
            },

            // Si el contratante viaja, su rango etario debe estar declarado en Datos del Viaje (cupo > 0).
            // Devuelve true si es válido (o si el contratante no viaja). Setea messageErrorAgeRange en caso de error.
            validateContractorAgeRange() {
                if (!this.isContractorTraveling || !this.nacimiento) {
                    this.messageErrorAgeRange = null;
                    return true;
                }
                const age = this.getAgeAtTripEnd(this.nacimiento);
                if (age !== null && age > MAX_PASSENGER_AGE) {
                    this.messageErrorAgeRange = `El contratante viaja y no puede tener más de ${MAX_PASSENGER_AGE} años a la fecha de regreso del viaje.`;
                    return false;
                }
                const grupo = this.getAgeGroup(this.nacimiento);
                if (!grupo || this.cuposDeclarados[grupo] <= 0) {
                    this.messageErrorAgeRange = grupo
                        ? `El contratante viaja y su rango (${GROUP_LABELS[grupo]}) no fue declarado en Datos del Viaje. Volvé a ajustar la cantidad de pasajeros por rango.`
                        : 'No se pudo determinar la edad del contratante.';
                    return false;
                }
                this.messageErrorAgeRange = null;
                return true;
            },

            // El tomador debe ser mayor de edad
            isOwnerOfLegalAge(result) {
                // Persona juridica sin control de edad (igual que AP).
                if (this.docTypeSelected && this.docTypeSelected.id === 'J') return true;
                return AgeService.checkAge(result.birthday, MIN_OWNER_AGE, Infinity).success;
            },

            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                } catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit('show-service-fail', statusCode, [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            pushServerError(paso) {
                var dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': this.email || (dataTabHome ? dataTabHome.email : null),
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'errorServidor',
                    'paso': paso
                });
            },

            getDocumentType() {
                documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length != 0) {
                        this.documentTypeList = response.map(element => ({ ...element, id: element["id"], text: element["name"] }));
                        this.docTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                    }
                }).catch(() => {
                    this.pushServerError('cotizador-asistencia-viaje-dni');
                })
            },

            getIvaConditions() {
                return ivaConditionService.getIvaConditionsList().then(response => {
                    if (response.length != 0) {
                        this.ivaConditionList = response.map(element => ({ ...element, id: element["id"].toString(), text: element["name"] }));
                    }
                }).catch(error => {
                    this.pushServerError('cotizador-asistencia-viaje-dni');
                    throw error;
                })
            },

            isSelectedDocumentType() {
                this.numDoc = "";
                this.searchButtonDisable = true;
                this.messageErrorAge = null;
            },

            searchPersonData() {
                this.getPersonByDocumentAndType();
            },

            getPersonByDocumentAndType() {
                this.activeFormPersonNoExist = false;
                this.messageErrorAge = null;
                var dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                NF.UI.Page.blockCustom({ message: 'Buscando datos..' });
                if (this.numDoc != null && this.numDoc != "") {
                    searchPersonService.GetSearchPersonData(this.numDoc, this.docTypeSelected.id)
                        .then(response => {
                            const results = response.searchPersonResult || [];
                            // Más de un registro para el mismo documento: pedir que elija la persona.
                            if (results.length > 1) {
                                this.openSelectMultiplePeopleModal(results);
                                return;
                            }
                            let result = results[0];
                            if (result != undefined && (result.firstName != "" && result.lastName != "" || result.razonSocial != undefined)) {
                                this.setPolicyOwnerFromResult(result, dataTabHome);
                            } else {
                                // Alineado a AP: si el contratante no existe en BUP, no se permite avanzar
                                this.activeForm = false;
                                this.isPersonExist = false;
                                this.activeFormPersonNoExist = false;
                                this.nextButtonDisable = true;
                                this.messageErrorAge = 'No encontramos registros con los datos ingresados. '
                                    + 'Podés contactarnos al '
                                    + '<a href="https://wa.me/5493493510404?from=numutiles" '
                                    + 'target="_blank" rel="noopener noreferrer">'
                                    + '+54 9 3493 510404</a> para ayudarte.';
                            }
                        }).then(() => NF.UI.Page.unblock())
                        .catch(() => {
                            // Falló la búsqueda en BUP: se registra el error y se desbloquea para poder reintentar.
                            this.pushServerError('cotizador-asistencia-viaje-dni');
                            NF.UI.Page.unblock();
                        });
                } else {
                    NF.UI.Page.unblock();
                }
            },

            // Setea el contratante con un registro de BUP (usado por el flujo de 1 resultado y por la selección del modal).
            setPolicyOwnerFromResult(result, dataTabHome) {
                // Menor de 18: no se carga el contratante y no se habilita Siguiente (igual que AP).
                if (!this.isOwnerOfLegalAge(result)) {
                    this.isPersonExist = false;
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.policyOwner = null;
                    this.ownerDocType = null;
                    this.nacimiento = null;
                    this.messageErrorAgeRange = null;
                    this.messageErrorAge = MIN_OWNER_AGE_MESSAGE;
                    this.nextButtonDisable = true;
                    return;
                }
                this.messageErrorAge = null;
                dataTabHome = dataTabHome || JSON.parse(sessionStorage.getItem("DataTabHome"));
                this.activeFormPersonNoExist = false;
                this.isPersonExist = true;
                this.activeForm = true;
                // Si la persona no tiene localidad en BUP se le pide la dirección (igual que AP).
                // Se limpian los campos por si se cambió de persona (modal de múltiples registros).
                this.hasLocality = result.hasLocality;
                this.selectedLocality = null;
                this.streetName = null;
                this.numDom = null;
                this.piso = null;
                this.numDept = null;
                this.nacimiento = result.birthday;
                this.firstName = result.firstName;
                this.lastName = result.lastName;
                this.email = dataTabHome ? dataTabHome.email : '';
                this.areaCode = dataTabHome ? dataTabHome.areaCode : '';
                this.telephone = dataTabHome ? dataTabHome.telephone : '';
                this.policyOwner = result;
                this.ownerDocType = this.getBupDocType(result) || this.docTypeSelected;
                this.selectedIvaCondition = result.ivaConditionFiscalId != null && result.ivaConditionFiscalId != 0 && result.ivaConditionFiscalId != undefined
                    ? (this.ivaConditionList.find(o => o.id == result.ivaConditionFiscalId || o.name == result.ivaConditionFiscalId))
                    : (this.ivaConditionList.find(o => o.id == 4 || o.name == "Consumidor Final"));
                // Al traer el tomador validamos su rango etario: si viaja y su rango no está declarado, no habilitamos Siguiente.
                this.nextButtonDisable = !this.validateContractorAgeRange();

                // GTM + Qualtrics: aparecen los datos de la persona para validar su identidad
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': this.email || null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'cotizador-asistencia-viaje-validar-ident'
                });
                window.globalThis._qsie = window.globalThis._qsie || [];
                window.globalThis._qsie.push('cotizador-asistencia-viaje-validar-ident');
            },

            getBupDocType(result) {
                const bupDocTypeId = result && result.document && result.document.identificationTypeCode
                    ? String(result.document.identificationTypeCode).trim()
                    : null;
                if (!bupDocTypeId) return null;
                return this.documentTypeList.find(dt => String(dt.id).trim() === bupDocTypeId) || null;
            },

            openSelectMultiplePeopleModal(peopleList) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                // Se guarda el registro crudo (con un id para el v-for/selección) y se reusa setPolicyOwnerFromResult.
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => ({ ...person, id: idCounter++ }));
                this.$refs.selectMultiplePeopleModal.open();
            },

            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
                this.multiplePeopleError = "";
            },

            closeSelectMultiplePeopleModal() {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                this.$refs.selectMultiplePeopleModal.close();
            },

            onSelectedClient(id) {
                this.personWithSameIdentifierSelected = id;
                const selectedPerson = this.multiplePeopleWithSameIdentifier.find(item => item.id === id);
                if (!selectedPerson) return;
                this.setPolicyOwnerFromResult(selectedPerson);
                this.closeSelectMultiplePeopleModal();
            },

            cancelMultiplePeopleSelection() {
                this.closeSelectMultiplePeopleModal();
            },

            validPhone() {
                if (this.telephone == "" && this.areaCode == "") return;
                return new Promise<any>(async (resolve) => {
                    await phoneValidateService.validatePhone(this.areaCode, this.telephone).then(o => {
                        this.messageErrorDigits = o.validCountDigit ? "" : (o.validCountDigit === false ? o.message : "");
                        resolve(o.validCountDigit);
                    });
                })
            },

            anterior() {
                sessionStorage.setItem("pressBackFromPolicyOwner", "true");
                this.$router.push({ name: 'travelAssistance-tab-three' });
            },

            // Ruleta de productor (igual que AP): se resuelve al confirmar el contratante y queda en
            // sesión backend, junto con el estado 20 del pricing. El backend prioriza la dirección de
            // BUP de la persona; la localidad de tab-one viaja como semilla para cuando no la tiene.
            startProducerDataTask() {
                return new Promise((resolve, reject) => {
                    const dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                    const locality = dataTabHome ? dataTabHome.selectedLocality : null;
                    getSelectedProducerService.GetSelectedProducer(
                        0,
                        locality ? locality.id : 0,
                        0,
                        4,
                        locality ? locality.zipCode : 0,
                        1018
                    ).then(() => {
                        resolve(true);
                    }).catch(error => {
                        reject(error);
                    });
                });
            },

            siguiente() {
                // Red final: si el contratante viaja, su rango etario debe estar declarado en Datos del Viaje.
                if (!this.validateContractorAgeRange()) {
                    this.nextButtonDisable = true;
                    return;
                }
                // Red final: la condición fiscal viaja como IvaConditionId del tomador al SaveEmission;
                // sin ella el Tarifador rechaza la emisión ("El valor es obligatorio para la 'Situación ante IVA'").
                if (!this.selectedIvaCondition) {
                    NF.Validation.Field.validate("#formData1", "selectedIvaCondition");
                    return;
                }
                NF.UI.Page.block();
                // Guardar contratante en session
                var contratante = this.policyOwner || {};

                // Dirección cargada en el front cuando la persona de BUP no tiene localidad (igual que AP):
                // si falta algún dato se corta acá; si están, viajan con el contratante hacia la emisión.
                if (!this.hasLocality) {
                    const faltaLocalidad = !this.selectedLocality || !this.selectedLocality.id;
                    const faltaCalle = !this.streetName || this.streetName.trim() === "";
                    const faltaNumero = !this.numDom || String(this.numDom).trim() === "";

                    if (faltaLocalidad || faltaCalle || faltaNumero) {
                        this.forceValidateAddressIfNeeded();
                        NF.UI.Page.unblock();
                        return;
                    }
                    else {
                        contratante.localityName = this.selectedLocality.name;
                        contratante.localityId = this.selectedLocality.id;
                        contratante.zipCode = this.selectedLocality.zipCode;
                        contratante.provinceName = this.selectedLocality.provinceName;
                        contratante.text = this.selectedLocality.text;
                        contratante.streetName = this.streetName;
                        contratante.numDom = this.numDom;
                        contratante.addresFromFront = true;
                    }
                }
                else {
                    contratante.addresFromFront = false;
                }

                contratante.email = this.email;
                contratante.areaCode = this.areaCode;
                contratante.telephone = this.telephone;
                contratante.firstName = this.firstName;
                contratante.lastName = this.lastName;
                contratante.ivaCondition = this.selectedIvaCondition;
                contratante.documentType = this.ownerDocType || this.docTypeSelected;
                contratante.documentNumber = this.numDoc;

                // Si cambió el tomador (otro documento), los pasajeros cargados con el tomador anterior se borrabn
                var prevContratante = JSON.parse(sessionStorage.getItem("contratante") || "null");
                if (prevContratante) {
                    var prevDocTypeId = prevContratante.documentType ? (prevContratante.documentType.id || prevContratante.documentType) : null;
                    var newDocTypeId = contratante.documentType ? (contratante.documentType.id || contratante.documentType) : null;
                    if (String(prevContratante.documentNumber) !== String(contratante.documentNumber) || String(prevDocTypeId) !== String(newDocTypeId)) {
                        sessionStorage.removeItem("passengers");
                    }
                }

                sessionStorage.setItem("contratante", JSON.stringify(contratante));
                sessionStorage.setItem("contractorTraveling", JSON.stringify(this.isContractorTraveling));
                sessionStorage.setItem("contractorBeneficiaries", JSON.stringify(this.isContractorTraveling ? this.contractorBeneficiaries : 'legalHeirs'));

                // Igual que AP: la ruleta corre antes de avanzar; si falla no se navega y se ofrece reintentar.
                this.startProducerDataTask()
                    .then(() => {
                        searchPersonService.SetCustomPerson("PolicyOwner", this.lastName, this.firstName);
                        this.$router.push({ name: 'travelAssistance-passengers' });
                    })
                    .catch(error => {
                        this.pushServerError('cotizador-asistencia-viaje-validar-ident');
                        const statusCode = error.response?.status;
                        this.Bus.$emit('show-service-fail', statusCode, [() => this.siguiente()]);
                    })
                    .finally(() => {
                        NF.UI.Page.unblock();
                    });
            },

            openCancelModal() { this.$refs.cancelModal.open(); },
            closeCancelModal() { this.$refs.cancelModal.close(); },
            cancelAndRedirect() {
                this.closeCancelModal();
                this.$router.push({ name: 'travelAssistance-tab-One' });
            },

            loadPlanData() {
                var planData = sessionStorage.getItem("SelectedTravelPlan");
                if (planData) {
                    var plan = JSON.parse(planData);
                    this.planDescription = plan.name;
                    this.planPrice = plan.priceFormatted;
                    this.planPriceArs = plan.priceArsFormatted || '';
                    // Capital de coberturas sin decimales.
                    this.covers = (plan.covers || []).map(c => ({
                        ...c,
                        capitalFormatted: (c.capital !== null && c.capital !== undefined)
                            ? `U$D ${Number(c.capital).toLocaleString('es-AR', { maximumFractionDigits: 0 })}`
                            : c.capitalFormatted,
                    }));
                }
                var travelData = sessionStorage.getItem("TravelDetailsData");
                if (travelData) {
                    var travel = JSON.parse(travelData);
                    if (travel.departureDate) this.departureDateFormatted = this.formatDate(travel.departureDate);
                    if (travel.returnDate) this.returnDateFormatted = this.formatDate(travel.returnDate);
                    // Fecha de fin del viaje + cupos declarados: la edad del contratante se calcula a esta fecha para validar el cupo.
                    this.tripEndDate = travel.returnDate || null;
                    this.cuposDeclarados = {
                        under21: travel.passengersUnder21 || 0,
                        between21And75: travel.passengersBetween21And75 || 0,
                        over75: travel.passengersOver75 || 0,
                    };
                }
            },
        },
        watch: {
            areaCode(newVal) {
                if (newVal != null && newVal != "") this.validPhone();
                this.messageErrorDigits = "";
            },
            telephone(newVal) {
                if (newVal != null && newVal != "") this.validPhone();
                else this.messageErrorDigits = "";
            },
            numDoc(newVal) {
                this.messageErrorAge = null;
                if (newVal == "" || newVal == null) {
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.isPersonExist = false;
                    this.nextButtonDisable = true;
                    this.searchButtonDisable = true;
                    this.messageErrorAgeRange = null;
                    this.hasLocality = null;
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDom = null;
                    this.piso = null;
                    this.numDept = null;
                }
            },
            isContractorTraveling() {
                // Al cambiar si el contratante viaja, revalidamos su rango etario contra los cupos declarados.
                if (this.isPersonExist) {
                    this.nextButtonDisable = !this.validateContractorAgeRange();
                }
            },
            hasLocality(newVal) {
                // Si NO tiene dirección, esos campos pasan a ser obligatorios
                this.$nextTick(() => this.setupAddressValidation(!newVal));
            },
            isPersonExist(newVal) {
                if (newVal) {
                    // Al resolver la persona, ajustamos según 'hasLocality'
                    this.$nextTick(() => this.setupAddressValidation(!this.hasLocality));
                }
            },
            selectedLocality() {
                if (!this.hasLocality) {
                    NF.Validation.Field.validate("#formData1", "selectedLocality");
                }
            },
            streetName() {
                if (!this.hasLocality) {
                    NF.Validation.Field.validate("#formData1", "streetName");
                }
            },
            numDom() {
                if (!this.hasLocality) {
                    NF.Validation.Field.validate("#formData1", "numDom");
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                await this.pageCustomization();
                this.updateByProductGoogleAnalytics();
                this.getDocumentType();
                // La lista de condiciones fiscales debe estar cargada antes de que el usuario pueda buscar
                // una persona: el find de setPolicyOwnerFromResult no tiene default posible con la lista vacía.
                await this.getIvaConditions();
                this.loadPlanData();
                this.setupAddressValidation(!this.hasLocality);
                sessionStorage.setItem("ExitOrContinueModal", "true");

                // GTM + Qualtrics: la pantalla arranca pidiendo el DNI del contratante
                var dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': dataTabHome ? dataTabHome.email : null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'cotizador-asistencia-viaje-dni'
                });
                window.globalThis._qsie = window.globalThis._qsie || [];
                window.globalThis._qsie.push('cotizador-asistencia-viaje-dni');
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
